module.exports = __webpack_public_path__ + "static/media/sessions.fa37418d.svg";